import type { MigrationProperty } from '@/types';

export function parseMetaFields(metaFields: string | null): MigrationProperty[] {
  if (!metaFields) return [];
  try {
    const parsed: unknown = JSON.parse(metaFields);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (item): item is MigrationProperty =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.key === 'string' &&
        typeof item.label === 'string' &&
        typeof item.type === 'string' &&
        ['string', 'integer', 'boolean'].includes(item.type),
    );
  } catch {
    return [];
  }
}

export function serializeMetaFields(properties: MigrationProperty[]): string {
  return JSON.stringify(properties);
}
